import styled from 'styled-components';

const BlogArticleLink = styled.a`
    text-decoration: none;
    &:focus, &:hover, &:visited, &:link, &:active {
        text-decoration: none;
    }
`;

export default BlogArticleLink;



// WEBPACK FOOTER //
// ./src/elements/BlogArticleLink.js